module.exports = __webpack_public_path__ + "img/yellow-watermelon-juice.4cbb7d2e.jpg";